module.exports = __webpack_public_path__ + "static/media/conferencias-eventos.bc03fbd9.jpg";